import GlobalMixin from './GlobalMixin';
import UtilMixin from './UtilMixin';

export default [
  GlobalMixin,
  UtilMixin,
];
